import { render } from "./Header.vue?vue&type=template&id=cd497422&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=cd497422&scoped=true&lang=scss"

import exportComponent from "/home/rlabrovi/Local Sites/vertikal/app/public/wp-content/plugins/climbing-card/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd497422"]])

export default __exports__